import { IconButton, Tooltip } from '@chakra-ui/react';
import { ReactComponent as CheckIcon } from 'assets/icons/check_circle_outline.svg';
import { useTranslation } from 'react-i18next';

interface InsertCheckboxButtonProps {
  onClick: () => void;
}

export const InsertCheckboxButton = ({ onClick }: InsertCheckboxButtonProps) => {
  const { t } = useTranslation('editor_widget_toolbar', { keyPrefix: 'tableToolbar.checkbox', useSuspense: false });
  const label = t('label');

  return (
    <Tooltip label={label}>
      <IconButton
        aria-label={label}
        onClick={onClick}
        variant='icon-btn-toolbar'
        size='sm'
        icon={<CheckIcon color='var(--vg-colors-font-500)' />}
      />
    </Tooltip>
  );
};
